
import PropTypes from "prop-types";
import React from "react";
import { NavLink } from "react-router-dom";
import "./style.css";

export const MenuItem = ({ className, text = "Item", divClassName, navto }) => {
  return (
    <div className={`menu-item ${className}`}>
      <NavLink
          to={navto}
          className={({ isActive, isPending }) =>
            isPending ? "item" : isActive ? "item active" : "item"
          }
          onClick={() => window.scrollTo(0, 0)}
        >
          {text}
        </NavLink>
    </div>
  );
};

MenuItem.propTypes = {
  text: PropTypes.string,
};
